import { v2ApiClient } from './apiClient';

export const enrollmentService = {
  async getEnrollInfo(code) {
    const response = await v2ApiClient.get(`/lms/class/enroll/info/${encodeURIComponent(code)}`);
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Failed to retrieve enrollment details');
  },

  async enrollByLink(code) {
    const response = await v2ApiClient.post('/lms/class/enroll/by-link', { code });
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Failed to join class via enrollment link');
  }
};

export default enrollmentService;
